import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import Auth0Client from '../../services/auth/auth0Client';
import { Button } from '@/components/ui/button';

const Auth0Initializer = ({ children }: { children: React.ReactNode }) => {
  const {
    getAccessTokenSilently,
    isLoading,
    isAuthenticated,
    loginWithRedirect,
    user,
  } = useAuth0();
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    if (!isLoading && isAuthenticated && getAccessTokenSilently) {
      Auth0Client.getInstance().initialize(getAccessTokenSilently, user);
      setIsInitialized(true);
    }
  }, [getAccessTokenSilently, isLoading, isAuthenticated, user]);

  if (!isAuthenticated) {
    return (
      <div className='flex items-center justify-center h-screen w-full flex-col'>
        <div className='w-[30vw]'>
          <h1 className='mb-8 text-4xl font-bold text-center'>
            Planner Configurator
          </h1>
          <ul className='mb-4 list-inside list-disc'>
            <li>
              For new users: you will need to request user access once logged in
            </li>
            <li>For existing users, no further actions needed</li>
          </ul>
          <Button
            size='lg'
            onClick={() => loginWithRedirect()}
            className='flex mr-2 items-center text-sm font-medium gap-2 h-8 border-solid border-2 rounded p-4 border-slate-800! bg-slate-800! text-white! dark:bg-white dark:border-white dark:text-black cursor-default w-full'
            isLoading={isLoading}
          >
            Login
          </Button>
        </div>
      </div>
    );
  }

  // Don't render children until Auth0 is ready and initialized
  if (isLoading || (isAuthenticated && !isInitialized)) {
    return null;
  }

  return children;
};

export default Auth0Initializer;
